/* eslint camelcase: ["error", {properties: "never"}] */
import Vue from 'vue';
import dayjs from 'dayjs';
import VueI18n from 'vue-i18n';
import ElementUI from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';

/**
 * Plugins
 * Import plugins here
 */
import './plugins/vue-axios';
import './plugins/vue-logger';
import './plugins/vue-anime';
import './plugins/element-ui';
import './plugins/dayjs';
import './plugins/vue-swiper';
import './plugins/vue-mask';
import './plugins/vue-idle';

/**
 * Main style
 * Import any additional style here
 */
import './assets/scss/styles.scss';

Vue.config.productionTip = false;

let deviceLanguage = '';

// set default language
if (localStorage.getItem('boxLang')) {
  deviceLanguage = localStorage.getItem('boxLang');
} else {
  deviceLanguage = 'de_AT';
}
localStorage.setItem('lang', deviceLanguage);

// get url + key and save into localStorage
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const apiUrl = urlParams.get('apiUrl');
if (apiUrl) {
  localStorage.setItem('unimarkt_outdoor_api_url', apiUrl);
}
// else {
//   localStorage.setItem('unimarkt_outdoor_api_url', process.env.VUE_APP_BASE_URL);
// }

const apiKey = urlParams.get('apiKey');
if (apiKey) {
  localStorage.setItem('unimarkt_outdoor_api_key', apiKey);
}
// else {
//   localStorage.setItem('unimarkt_outdoor_api_key', process.env.VUE_APP_X_API_KEY);
// }

// init load language
store.dispatch('setI18nDataOutdoor', deviceLanguage).then((response) => {
  localStorage.removeItem(deviceLanguage);
  localStorage.removeItem('lang');
  localStorage.setItem(deviceLanguage, response.messages[`${deviceLanguage}`]);
  localStorage.setItem('lang', deviceLanguage);

  const i18n = new VueI18n({
    locale: deviceLanguage,
    fallbackLocale: deviceLanguage,
  });

  // set default messages
  i18n.setLocaleMessage(deviceLanguage, response.messages[`${deviceLanguage}`]);

  // update element UI component languages
  Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value),
  });

  // error handler
  Vue.config.errorHandler = (err, vm, info) => {
    store.dispatch('setUserOutdoor').then(async (res) => {
      if (res) {
        const data = {
          userID: res.id,
          appView: vm.$route.path,
          appError: `${err.toString()}`,
          appErrorDestination: info,
          dateTime: dayjs().format('DD.MM.YYYY HH:mm:ss'),
        };

        store.dispatch('setError', {
          appType: 'Tür',
          deviceType: 'Tür',
          jsonData: data,
        });
      } else {
        const data = {
          appView: vm.$route.path,
          appError: `${err.toString()}`,
          appErrorDestination: info,
          dateTime: dayjs().format('DD.MM.YYYY HH:mm:ss'),
        };

        store.dispatch('setError', {
          appType: 'Tür',
          deviceType: 'Tür',
          jsonData: data,
        });
      }
    });
  };

  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
});
